export default function formatName(context, name) {
  var sectionPrefix = context._reduxForm.sectionPrefix;

  return !sectionPrefix ? name : sectionPrefix + "." + name;
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/redux-form@6.8.0_btckld2a72haxcqt7vtk4t56yu/~/redux-form/es/util/prefixName.js
// module id = 57
// module chunks = 0